<style lang="scss" scoped>
@import '@@/assets/css/global.scss';
.page_content {
	height: 100%;
	box-sizing: border-box;
	.eq-list {
		padding: 20px;
		padding-top: 0px;
		box-sizing: border-box;
		display: grid;
		// grid-column: 10;
		grid-template-columns: repeat(8,calc((100% - 70px) / 8)) ;
		grid-row-gap: 10px;
		grid-column-gap: 10px;
		.eq {
			color: white;
			display:flex ;
			justify-content: center;
			align-items: center;
			border-radius: 4px;
			box-sizing: border-box;
			.infos {
				position: relative;
				padding: 8px;
				.name {

					font-size: 18px;
					font-weight: bold;
				}
				.params {
					display: flex;
					justify-content: space-between;
					flex-wrap: wrap;
					.param {
						word-wrap: break-word;
						font-size: 16px;
						width: 49%;
						color: white;
					}
				}
				.state {
					position: absolute;
					top: 0px;
					right: 0px;
					background-color: rgba($color: #ffffff, $alpha: 0.3);
					height: 32px;
					width: 60px;
					font-size: 14px;
					border-top-left-radius: 16px;
					border-bottom-left-radius: 16px;
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}

			.status {
				color: white;
			}
			.line {
				margin-top: 6px;
				padding-right: 16px;
			}
		}

		.run {
			background: $c-success;
		}
		.error {
			background: $c-error;
		}

		.idle {
			background: $c-warning;
		}

		.offline {
			background: $c-info;
		}

		.err {
			animation: 1.5s flash linear infinite normal;

			@keyframes flash {
				0% {
					opacity: 1;
				}

				50% {
					opacity: 0.7;
				}

				100% {
					opacity: 0.2;
				}
			}
		}
	}
}
</style>
<template>
	<div v-loading="loading" class="page_content" ref="page_content">
		<div class="eq-list">
			<div v-for="(eq, index) in eqs" :key="index">
				<div
					class="eq"
					ref="eq"
					:class="{
						run: eq.codePointsMap['CurrentState'].v == 0 || eq.codePointsMap['CurrentState'].v == 2,
						error: eq.codePointsMap['CurrentState'].v == 3,
						offline: eq.codePointsMap['CurrentState'].v == -1 || eq.codePointsMap['CurrentState'].v == undefined,
						idle: eq.codePointsMap['CurrentState'].v == 1,
					}"
					:style="{'height':height+'px'}"
					@click="$emit('chooseEq',eq)"
				>
					<div class="infos">
						<div class="name">{{ eq.name }}</div>
						<!-- <div class="params">
							<div class="param">sn: {{ eq.equipmentSn }}</div>
							<div v-for="code in eq.showJson.workshop.card" :key="code" class="param">
								{{ $t(eq.codePointsMap[code].i18nKey) }}:{{ eq.codePointsMap[code].v | pformat(eq.codePointsMap[code]) }}
							</div>
						</div>
						<div class="state">
							<span v-if="eq.codePointsMap['CurrentState'].v == 0 || eq.codePointsMap['CurrentState'].v == 2">{{ $t('运行') }}</span>
							<span v-if="eq.codePointsMap['CurrentState'].v == 1">{{ $t('空闲') }}</span>
							<span v-if="eq.codePointsMap['CurrentState'].v == 3">{{ $t('故障') }}</span>
							<span v-if="eq.codePointsMap['CurrentState'].v == -1 || eq.codePointsMap['CurrentState'].v == undefined">{{ $t('离线') }}</span>
						</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'eq_list',
	components: {},
	props: {
		bind: {
			type: Boolean,
			default: false,
		},
		sn: {
			type: String,
			default: '',
		},
		autoSelect: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			loading: false,
			height:0,
		};
	},

	computed: {
		...Vuex.mapState(['equipmentsMap']),
		eqs() {
			return Object.values(this.equipmentsMap)
				.filter(eq => {
					if(this.bind){
						return !this.store.state.bind_sn || eq.equipmentSn == this.store.state.bind_sn;
					}else{
						return true;
					}
				})
				.sort((eq1, eq2) => {
					return eq1.priority - eq2.priority;
				});
		},
	},
	watch: {
		sn(n, o) {

		},
	},
	created() {
		this.refreshEq();
	},
	mounted() {
		let a = setInterval(()=>{
			if(this.eqs.length>0){
				this.height = (this.$refs.eq)[0].offsetWidth

				setTimeout(()=>{
					if(this.sn == ''&&this.autoSelect==true){
						this.$emit('chooseEq',this.eqs[0])
						this.sn = this.eqs[0].equipmentSn
					}
				},300)



				clearInterval(a)
				return
			}
		},1000)
	},
	beforeDestroy() {},

	methods: {
		...Vuex.mapActions(['refreshEqData']),
		// ...mapMutations(['updatePointMtt', 'changeSn']),
		refreshEq() {
			if (this.sn == null || this.sn == '') {
				return;
			}
			let snPointArr = [];
			snPointArr.push({
				sn: this.sn,
				nodes: ['CurrentState'],
			});
			let delay = 0;

			this.loading = true;
			Promise.all([
				//获取生产进度
				this.getProductionInfo(),
				//刷新设备数据
				this.refreshEqData({
					snPointArr,
					delay,
				}),
			])
				.then(res => {
					this.productionInfo = res[0];
					this.loading = false;
				})
				.catch(() => {
					//失败的话三秒后再请求设备信息
					setTimeout(() => {
						this.refreshEq();
					}, 3000);
				});
		},

	},
};
</script>
